<template>
  <Analysis :project="vid" embed data-testid="analysis-component"></Analysis>
</template>

<script>
import Analysis from '../../../flux/views/AnalysisNew.vue';

export default {
  name: 'financialclose_varienceanalysis_analysis',
  // props: ['props'],
  data: function () {
    return {
      vid: "",
    }
  },
  components: {
    Analysis
  },
  created() {
    this.vid = localStorage.getItem("VarianceAnalysis_id");
  },
  activated() {
    this.vid = localStorage.getItem("VarianceAnalysis_id");
  },

  methods: {
    refreshData() {
    },

  },
  computed: {
  },
  watch: {
  }
}
</script>

